<div class="card-body">
  <form [formGroup]="leadForm" (ngSubmit)="onSubmit();">
    <div class="row">
      <div class="col-md-12" *ngIf="counter == 1">
        <div class="card card-primary">
          <div class="card-header">
            <h3 class="card-title">Customer Details </h3>
          </div>
          <div class="card-body" style="display: block;">
            <div class="form-group">
              <label for="inputName">Customer Name</label>
              <input type="text" id="inputName" class="form-control" formControlName="name" required>
              <p *ngIf="leadForm.get('name').invalid" class="error">*name is required</p>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="contact">Contact Number</label>
                <input type="tel" id="contact" class="form-control" formControlName="contact_1">
                <p *ngIf="leadForm.get('contact_1').invalid" class="error">*contact number is required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="alternateContact">Alternate Contact Number</label>
                <input type="tel" id="alternateContact" class="form-control" formControlName="contact_2">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="email">Email</label>
                <input type="email" id="email" class="form-control" formControlName="email">
                <p *ngIf="leadForm.get('email').invalid" class="error">*email is required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="job">Occupation</label>
                <input type="text" id="job" class="form-control" formControlName="job" required>
                <p *ngIf="leadForm.get('job').invalid" class="error">*Occupation is required</p>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="aadhar_no">Aadhar No.</label>
                <input type="aadhar_no" id="aadhar_no" class="form-control" formControlName="aadhar_no">
                <p *ngIf="leadForm.get('aadhar_no').invalid" class="error">*aadhar no is required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="pan_no">PAN No.</label>
                <input type="text" id="pan_no" class="form-control" formControlName="pan_no" required>
                <p *ngIf="leadForm.get('pan_no').invalid" class="error">*pan no is required</p>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="address">Address</label>
                <textarea id="address" class="form-control" rows="4" formControlName="address"></textarea>
                <p *ngIf="leadForm.get('address').invalid" class="error">*address is required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="notes">Remarks</label>
                <textarea id="notes" class="form-control" rows="4" formControlName="notes"></textarea>
                <small>Any additional information</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" *ngIf="counter == 2">
        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">Property Details</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="inputEstimatedBudget">Property ID</label>
                <input (change)="pselect(leadForm.get('pid').value)" list="plot_numbers" class="form-control" formControlName="pid">
                <datalist id="plot_numbers">
                  <option *ngFor="let pid of pids" value="{{pid.pid}}">
                </datalist>
                <p *ngIf="leadForm.get('pid').invalid" class="error">*property id required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="source">Source</label>
                <select class="form-control" name="source" id="source" formControlName="source">
                  <option value="social">Social Media</option>
                  <option value="paper-ads">Paper Ads</option>
                  <option value="channel-partner">Channel Partner</option>
                  <option value="walk-in">Walk in</option>
                </select>
                <p *ngIf="leadForm.get('source').invalid" class="error">*source is required</p>
              </div>
            </div>
            <div class="row" *ngIf="leadForm.get('source').value === 'channel-partner'" >
              <div class="form-group col-md-6">
                <label for="agent">Channel Partner</label>
                <select class="form-control" name="channel_partner" id="channel_partner" formControlName="channel_partner"
                (change)="getSubBrokers(leadForm.get('channel_partner').value);">
                  <option value="" disabled>Select a channel Partner</option>
                  <option [value]="item.id" *ngFor="let item of channelPartners">{{item.name}}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label >Sub Broker</label>
                <select class="form-control" name="sub_broker" id="sub_broker" formControlName="sub_broker">
                  <option value="null" selected>None</option>
                  <option [value]="item.id" *ngFor="let item of subBrokers">{{item.name}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <div class="row" *ngIf="selectedProperty !== 'plot'">
                  <div class="col-md-6">
                    <label >Floor</label>
                    <input type="number" placeholder="Inventory" class="form-control" formControlName="inventory">
                  </div>
                  <div class="col-md-6">
                    <label >Floor Price</label>
                    <input type="number" placeholder="price" class="form-control" formControlName="inventory_price">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label >IFMS</label>
                    <input type="number" placeholder="EDC" class="form-control" formControlName="edc">
                  </div>
                  <div class="col-md-6">
                    <label >GST (%)</label>
                    <input type="number" placeholder="GST" class="form-control" formControlName="gst">
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label >BSP</label>
                    <input type="number" placeholder="base price" class="form-control" formControlName="base_price">
                  </div>
                  <div class=" form-group col-md-12">
                    <label >Final Property Cost</label>
                    <input type="number" placeholder="property cost" class="form-control" formControlName="property_cost">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div>
                  <p><strong>Property Type : </strong> {{selectedProperty}}</p>
                </div>
                <div formArrayName="plc">
                  <div class="form-group" *ngFor="let group of plcArray.controls; let i = index;" [formGroupName]="i">
                    <label>PLC {{i+1}}</label>
                    <div class="row">
                      <div class="col-md-6">
                        <label> PLC Name</label>
                        <input type="text" placeholder="plc name" class="form-control" formControlName="plc_name">
                      </div>
                      <div class="col-md-6">
                        <label> PLC Price (%)</label>
                        <input type="number" placeholder="price" class="form-control" formControlName="price">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" *ngIf="counter == 3">
        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">Payment Details</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="emiCost">Total Amount</label>
                <input type="number" id="emiCost" class="form-control"
                formControlName="emi_ammount">
                <small>Final Cost is {{ leadForm.get('property_cost').value |currency:'INR':'symbol'}}</small>
              </div>
              <div class="form-group col-md-6">
                <label>Payment plan:</label>
                <select class="form-control" formControlName="payment_plan" (change)="setTenure()">
                  <option value="clp">CLP/DLP</option>
                  <option value="downpayment">Down Payment</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group  col-md-6" *ngIf="leadForm.get('payment_plan').value === 'downpayment'">
                <label for="payment_tenure">Payment tenure</label>
                <input type="number" id="payment_tenure" name="payment_tenure" class="form-control" value="2" disabled
                formControlName="payment_tenure">
                <small>For downpayment plan 2</small>
              </div>
              <div class="form-group  col-md-6" *ngIf="leadForm.get('payment_plan').value === 'clp'">
                <label for="payment_tenure">Payment tenure</label>
                <input type="number" id="payment_tenure" name="payment_tenure" class="form-control" formControlName="payment_tenure">
                <small>Number of EMI.</small><br>
              </div>
              <div class="form-group col-md-6">
                <label>First Payment Date:</label>
                <div class="input-group">
                  <div class="input-group-prepend" (click)="dp.toggleCalendar()">
                    <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                  </div>
                  <input class="form-control" placeholder="Select a date" angular-mydatepicker   name="first_payment_date" (click)="dp.toggleCalendar()" autocomplete="off"
                    formControlName="first_payment_date"[options]="myOptions" #dp="angular-mydatepicker"/>
                </div>
                <small>First EMI/ Down Payment Date</small>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">

        <button type="button" class="btn btn-secondary float-right" style="margin: 0px 10px;"
        [disabled]="counter == 3"
        (click)="next();" >Next</button>

        <input type="submit" value="Create Customer" class="btn btn-success" [disabled]="!leadForm.valid">

        <button type="button" class="btn btn-secondary float-left" style="margin: 0px 10px;"
        [disabled]="counter == 1"
        (click)="back();" >Back</button>

      </div>
    </div>
  </form>
</div>
